import React, { useEffect } from 'react';
import { ChakraProvider, theme, Spinner } from '@chakra-ui/react';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import CarInfo from './pages/CarInfo';

import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import VerifyOtpPage from './pages/VerifyOtpPage';
import VerifyOtpLoginPage from './pages/VerifyOtpLoginPage';
import VerifyOtpSignUpPage from './pages/VerifyOtpSignUpPage';
import Profile from './pages/profile';
import Dashboard from './pages/Dashboard';
import ForgetPasswordPage from './pages/ForgetPage';
import ServicesPage from './pages/ServicesPage';
import ResetPassword from './pages/ResetPasswordPage';
import AddVehiclePage from './pages/AddVehiclePage';
import VehicleDetailsPage from './pages/VehicleDetailsPage';
import { useQuery } from '@tanstack/react-query';
import Settings from './Components/Settings';
import MediaLoader from './Components/MediaLoader';
import PasswordGate from './Components/PasswordGate/PasswordGate';
import PublicRoute from './Components/PublicRoute';
import { getValidToken, initTokenExpiryWatcher } from './utils/tokenManager';


function App() {
  const { data: token } = useQuery(
    ['token'],
    getValidToken,
    {
      // Don't refetch if we already have the token
      staleTime: Infinity,
      // Initialize with localStorage value immediately
      initialData: getValidToken(),
    }
  );

  useEffect(() => {
    const cleanup = initTokenExpiryWatcher();
    return () => {
      if (cleanup) {
        cleanup();
      }
    };
  }, []);



  if (token === undefined) {
    return <Spinner size="xl" />;
  }

  return (
    <PasswordGate>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <MediaLoader />

        <Routes>
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/dashboard/settings" element={<Settings />} />
          <Route path="/dashboard/add-vehicle" element={<AddVehiclePage />} />
          <Route path="/vehicle-details" element={<PublicRoute><VehicleDetailsPage /></PublicRoute>} />
          <Route path="/carinfo/" element={<CarInfo />} />
          <Route path="/profile/*" element={<Profile />} />
          <Route path="/forget-password" element={<PublicRoute><ForgetPasswordPage /></PublicRoute>} />
          <Route path="/verify-otp" element={<PublicRoute><VerifyOtpPage /></PublicRoute>} />
          <Route path="/verify-otp-login" element={<PublicRoute><VerifyOtpLoginPage /></PublicRoute>} />
          <Route path="/verify-otp-signup" element={<PublicRoute><VerifyOtpSignUpPage /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/sign-in/*" element={<PublicRoute><SignIn /></PublicRoute>} />
          <Route path="/sign-up/*" element={<PublicRoute><SignUp /></PublicRoute>} />
          <Route path="/" element={<PublicRoute><ServicesPage /></PublicRoute>} />
          <Route path="/*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
    </PasswordGate>
  );
}

export default App;
